import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  standalone: false,
  selector: 'esp-new-hire-mu-link-cell-renderer',
  templateUrl: './new-hire-mu-link-cell-renderer.component.html',
  styleUrls: ['./new-hire-mu-link-cell-renderer.component.scss']
})
export class NewHireMuLinkCellRendererComponent implements ICellRendererAngularComp {
  params: ICellRendererParams;
  muName: string = '';
  classData: any = null;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    // Try to get the management unit name from params
    if (params.value) {
      this.muName = params.value;
    } else if (params.data && params.data.managementUnit) {
      this.muName = params.data.managementUnit;
    }
    
    this.classData = params.data;

  }

  refresh(params: ICellRendererParams): boolean {
    this.agInit(params);
    return true;
  }

  onClick(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    
    // If this is a class row, trigger edit mode
    if (this.classData && this.params.context && this.params.context.onEditClass) {
      this.params.context.onEditClass(this.classData);
    } else {
      console.log('Management Unit link clicked:', this.muName, this.params);
    }
  }
} 